"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexAlignCenterStretch = void 0;

var _emotion = require("emotion");

var flexAlignCenterStretch =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;align-self:stretch;");
exports.flexAlignCenterStretch = flexAlignCenterStretch;